"use client";

import React, { createContext, useContext, useState, useCallback } from 'react';

interface PageTitleContextType {
  title: string;
  gymName: string;
  setTitle: (title: string, gymName?: string) => void;
}

const PageTitleContext = createContext<PageTitleContextType | undefined>(undefined);

export const PageTitleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [title, setTitle] = useState<string>('');
  const [gymName, setGymName] = useState<string>('');

  const handleSetTitle = useCallback((newTitle: string, newGymName?: string) => {
    setTitle(newTitle);
    if (newGymName !== undefined) {
      setGymName(newGymName);
    }
  }, []);

  return (
    <PageTitleContext.Provider value={{ title, gymName, setTitle: handleSetTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
};

export const usePageTitleContext = () => {
  const context = useContext(PageTitleContext);
  if (context === undefined) {
    throw new Error('usePageTitleContext must be used within a PageTitleProvider');
  }
  return context;
};
